import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ContentBox from "src/components/ContentBox/ContentBox";
import Footer from "src/components/footer/footer";
import Header from "src/components/header/header";
import { textStyle } from "src/styles/textstyle";
import { AccordionWrapper } from "../MainPage/Components/StillUnsure";
import { Box, ThemeProvider } from "@mui/material";
import { useEffect } from "react";
import {
  aboutHomeSwap,
  accountDetails,
  arrangingTheSwap,
  community,
  guideLines,
  technicalSupport,
} from "src/media/texts/faq_main";
import theme from "src/styles/mainstyle";
import GeneralInfo from "./Components/GeneralInfo";
import GoodAdvices from "./Components/GoodAdvices";
import HomeSwapTrustAndSafetyFramework from "./Components/HomeSwapTrustAndSafetyFramework";

export default function FAQMain() {
  useEffect(() => {
    if (window.location.hash) {
      const element = document.getElementById(
        window.location.hash.substring(1),
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <Box sx={{ pt: 15 }} />
      <GeneralInfo />
      <GoodAdvices />
      <HomeSwapTrustAndSafetyFramework />
      <ContentBox title="FAQ" id="faq-main">
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Grid container spacing={5}>
              <Grid item md={6} xs={12}>
                <Typography
                  variant="h3"
                  sx={{
                    ...textStyle,
                    fontWeight: "bold",
                    marginBottom: "20px",
                  }}
                >
                  About Home Swap
                </Typography>
                <Grid item xs={12} md={8}>
                  {aboutHomeSwap.map((item, index) => (
                    <AccordionWrapper
                      key={index}
                      question={"• " + item.header}
                      answer={item.answer}
                      smallVersion={true}
                    />
                  ))}
                </Grid>
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography
                  variant="h3"
                  sx={{
                    ...textStyle,
                    fontWeight: "bold",
                    marginBottom: "20px",
                  }}
                >
                  Arranging the swap
                </Typography>
                {/* </Grid> */}
                <Grid item xs={12} md={8}>
                  {arrangingTheSwap.map((item, index) => (
                    <AccordionWrapper
                      key={index}
                      question={"• " + item.header}
                      answer={item.answer}
                      smallVersion={true}
                    />
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h3"
                  sx={{
                    ...textStyle,
                    fontWeight: "bold",
                    marginBottom: "20px",
                  }}
                >
                  Account details
                </Typography>
                <Grid item xs={12} md={8}>
                  {accountDetails.map((item, index) => (
                    <AccordionWrapper
                      key={index}
                      question={"• " + item.header}
                      answer={item.answer}
                      smallVersion={true}
                    />
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h3"
                  sx={{
                    ...textStyle,
                    fontWeight: "bold",
                    marginBottom: "20px",
                  }}
                >
                  Technical support
                </Typography>
                {/* </Grid> */}
                <Grid item xs={12} md={8}>
                  {technicalSupport.map((item, index) => (
                    <AccordionWrapper
                      key={index}
                      question={"• " + item.header}
                      answer={item.answer}
                      smallVersion={true}
                    />
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h3"
                  sx={{
                    ...textStyle,
                    fontWeight: "bold",
                    marginBottom: "20px",
                  }}
                >
                  Guidlines
                </Typography>
                <Grid item xs={12} md={8}>
                  {guideLines.map((item, index) => (
                    <AccordionWrapper
                      key={index}
                      question={"• " + item.header}
                      answer={item.answer}
                      smallVersion={true}
                    />
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h3"
                  sx={{
                    ...textStyle,
                    fontWeight: "bold",
                    marginBottom: "20px",
                  }}
                >
                  Community
                </Typography>
                {/* </Grid> */}
                <Grid item xs={12} md={8}>
                  {community.map((item, index) => (
                    <AccordionWrapper
                      key={index}
                      question={"• " + item.header}
                      answer={item.answer}
                      smallVersion={true}
                    />
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
      <Footer />
    </ThemeProvider>
  );
}
